// src/mobile/index.ts
import { setNavigationBarConfig } from './navigation';
import {
  setDetailNavigationBarConfig,
  removeDetailNavigationBarListeners,
} from './detail-navigation';
import {
  setSubNavigationConfig,
  updateSubNavigationItem,
  setSelectedSubNavigationItem,
} from './sub-navigation';
import { setFloatingActionButtonConfig } from './fab';
import { activeSearch, cancelSearch } from './search';
import {
  registerEvent,
  unregisterEvent,
  removeEventAllListeners,
} from './event-manager';

export const mobileUI = {
  setNavigationBarConfig,
  setDetailNavigationBarConfig,
  removeDetailNavigationBarListeners,
  setSubNavigationConfig,
  setSelectedSubNavigationItem,
  updateSubNavigationItem,
  setFloatingActionButtonConfig,
  registerEvent,
  activeSearch,
  cancelSearch,
  unregisterEvent,
  removeEventAllListeners,
};
